import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock, Gift } from "lucide-react";
import { api, API } from "@/lib/api";
import { formatDate, formatDay } from "@/lib/constants";
import { REWARD_TYPES } from "@/components/RewardCard";
import { RedemptionView } from "@/components/RedemptionView";
import { Linkify } from "@/components/Linkify";

function Validity({ d }) {
  if (!d.valid_until) return <span className="text-[#1f5f42]">Бессрочно</span>;
  return <span className={d.expired ? "text-red-600" : "text-[#1f5f42]"}>{d.expired ? "Истёк" : "Действует до"} {formatDay(d.valid_until)}</span>;
}

function MyRewardCard({ d }) {
  const [img, setImg] = useState(true);
  const T = REWARD_TYPES[d.reward_type] || REWARD_TYPES.gift;
  return (
    <div className={`rounded-2xl bg-white border border-[#d1e7dd] overflow-hidden flex flex-col sm:flex-row ${d.expired ? "opacity-70" : ""}`} data-testid={`my-reward-${d.id}`}>
      <div className="sm:w-56 aspect-[16/9] sm:aspect-auto shrink-0 bg-[#1f5f42] grid place-items-center">
        {img ? <img src={`${API}/rewards/${d.reward_id}/cover`} alt="" onError={() => setImg(false)} className="w-full h-full object-cover" /> : <T.icon className="h-10 w-10 text-[#a3e6be]" />}
      </div>
      <div className="p-5 flex-1 space-y-3">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-display font-bold text-lg text-[#0b2e20]">{d.title}</span>
          <span className="text-[11px] font-bold uppercase px-2 py-0.5 rounded bg-[#e8f5ed] text-[#1f5f42]">{T.name}</span>
          {d.expired && <span className="text-[11px] font-bold uppercase px-2 py-0.5 rounded bg-red-50 text-red-700" data-testid={`my-reward-expired-${d.id}`}>Истёк</span>}
        </div>
        <div className="text-sm flex items-center gap-1.5 font-semibold" data-testid={`my-reward-validity-${d.id}`}><CalendarClock className="h-4 w-4" /><Validity d={d} /></div>
        <RedemptionView d={d} />
        {d.delivery_method && d.reward_type !== "gift" && <p className="text-xs text-[#4b6b5c] break-words">Способ получения: <Linkify text={d.delivery_method} /></p>}
        <p className="text-xs text-[#8aa699]">Получено {formatDate(d.created_at)} · {d.cost} коинов</p>
      </div>
    </div>
  );
}

export default function MyRewardsPage() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/redemptions/mine").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-[#0b2e20] rise">Мои награды</h1>
      <p className="text-[#4b6b5c] mt-3">Все полученные награды, промокоды и сертификаты со сроком действия.</p>
      <div className="mt-8 space-y-4" data-testid="my-rewards-list">
        {items && items.length === 0 && (
          <div className="text-center py-16 border-2 border-dashed border-[#d1e7dd] rounded-2xl" data-testid="my-rewards-empty">
            <Gift className="h-10 w-10 mx-auto text-[#a3c9b4]" />
            <p className="font-semibold text-[#1f5f42] mt-3">Вы ещё ничего не обменяли</p>
            <Link to="/rewards" className="text-sm text-[#2e7d56] underline mt-1 inline-block" data-testid="my-rewards-go-shop">Перейти к наградам</Link>
          </div>
        )}
        {(items || []).map((d) => <MyRewardCard key={d.id} d={d} />)}
      </div>
    </div>
  );
}
